import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CarrierConfigurationListItemDto } from '@carrier-configurations/models/carrier-configuration.model';
import { TranslocoModule } from '@jsverse/transloco';
import '@maersk-global/mds-components-core-table';
import '@maersk-global/mds-components-core/mc-button';
import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types.js';

@Component({
  selector: 'carrier-configurations-table',
  imports: [TranslocoModule],
  templateUrl: 'carrier-configurations-table.component.html',
  styleUrl: 'carrier-configurations-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarrierConfigurationsTableComponent {
  @Input() tableData: CarrierConfigurationListItemDto[] = [];
  @Input() tableColumns: TableColumn[] = [];
  @Input() isLoading = false;
  @Input() versionCountByCarrier: Record<string, number> = {};
  @Output() rowClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() editClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() activateClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() switchActiveVersionClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() testClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() deleteClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();
  @Output() trackingClicked: EventEmitter<CarrierConfigurationListItemDto> =
    new EventEmitter();

  getVersionCount(row: CarrierConfigurationListItemDto): number {
    return this.versionCountByCarrier[row.carrierCode ?? ''] ?? 1;
  }

  showActivate(row: CarrierConfigurationListItemDto): boolean {
    return row.activeVersion == null && this.getVersionCount(row) === 1;
  }

  showSwitchActiveVersion(row: CarrierConfigurationListItemDto): boolean {
    return this.getVersionCount(row) > 1;
  }

  onRowClicked(event: Event) {
    const row = (event as CustomEvent).detail?.rowData;
    if (row) {
      this.rowClicked.emit(row);
    }
  }

  onMenuSelected(event: Event, row: CarrierConfigurationListItemDto) {
    const value = (event as CustomEvent).detail?.item?.value;
    if (value === 'edit') {
      this.editClicked.emit(row);
      return;
    }

    if (value === 'activate') {
      this.activateClicked.emit(row);
      return;
    }

    if (value === 'switch_active_version') {
      this.switchActiveVersionClicked.emit(row);
      return;
    }

    if (value === 'test') {
      this.testClicked.emit(row);
      return;
    }

    if (value === 'delete') {
      this.deleteClicked.emit(row);
      return;
    }

    if (value === 'tracking') {
      this.trackingClicked.emit(row);
    }
  }
}
